/* eslint-disable no-console */
/* eslint-disable import/no-import-module-exports */
/* eslint-disable react/no-deprecated */
import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import { hydrate } from 'react-dom'
import App from './platform/index'

hydrate(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept()
}
